module.exports = __webpack_public_path__ + "static/img/die-entsorger.991a407.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/die-entsorger.png
// module id = 469
// module chunks = 1